// src/components/layout/mobile/MobileLayout.tsx
import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { ErrorBoundary } from '@/components/common';
import { SessionWarningDialog } from '@/components/common/SessionWarningDialog';
import { InstallBanner } from '@/components/common/InstallBanner';
import { OfflineBanner } from '@/components/common/OfflineBanner';
import { MobileHeader } from './MobileHeader';
import { BottomTabBar } from './BottomTabBar';
import { MobileCreateSheet } from './MobileCreateSheet';

interface MobileLayoutProps {
  notificationCount: number;
  showWarning: boolean;
  countdownSeconds: number;
  onDismissWarning: () => void;
  onLogout: () => void;
}

export function MobileLayout({
  notificationCount,
  showWarning,
  countdownSeconds,
  onDismissWarning,
  onLogout,
}: MobileLayoutProps) {
  const [createOpen, setCreateOpen] = useState(false);

  return (
    <div className="flex flex-col h-dvh bg-background">
      {/* Offline banner — pushes content */}
      <OfflineBanner />

      <MobileHeader onLogout={onLogout} />

      <main className="flex-1 overflow-y-auto overscroll-y-contain">
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      </main>

      <BottomTabBar
        notificationCount={notificationCount}
        onCreatePress={() => setCreateOpen(true)}
      />

      {/* Create action sheet */}
      <MobileCreateSheet
        open={createOpen}
        onOpenChange={setCreateOpen}
      />

      {/* Session idle warning */}
      <SessionWarningDialog
        open={showWarning}
        countdownSeconds={countdownSeconds}
        onContinue={onDismissWarning}
      />

      {/* PWA install banner */}
      <InstallBanner />
    </div>
  );
}
